<div class="mt-image-form">
  <div class="mt-image-form-header">
    <div class="mt-back-button" (click)="goBack()">
      <mitter-back-icon ></mitter-back-icon>
    </div>
  </div>

  <div class="mt-image-form-content">
    <img *ngIf="file" class="mt-image" alt='' #selectedImage>

    <input type="file" #fileSelector class="mt-file-picker"
      name="mt-file-picker" id="mt-file-picker"
      (change)="onChange(fileSelector.files)"
      (keydown)="handleKeyDown($event)"
      accept="image/*"
    />

    <label class="mt-file-picker-button" for="mt-file-picker">
      Choose file to upload
    </label>
  </div>

  <div *ngIf="isPrescription" class="mt-prescription-notification">
    You are typing a prescription
  </div>

  <div *ngIf="file" class="mt-image-form-footer">
    <input type='text' class='mt-caption-input'
      [(ngModel)]="textPayload" placeholder='Add caption'
    />

    <div class="mt-icon-precription" *ngIf="isDoctor" (click)="togglePrescription()">
      <mitter-prescription-on-icon *ngIf="isPrescription; else offIcon">
      </mitter-prescription-on-icon>
    </div>

    <ng-template #offIcon>
      <mitter-prescription-off-icon></mitter-prescription-off-icon>
    </ng-template>

    <div class="mt-icon-send" (click)="sendImageMessage()">
      <mitter-send-icon></mitter-send-icon>
    </div>
  </div>
</div>
